import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-b-small', 'IconLetterBSmall', [
  [
    'path',
    { d: 'M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z', key: 'svg-0' },
  ],
]);
